<header class="pt-topbar bg-accent">
  <div class="container">
    <div class="section-inset-t pb-3 pb-md-4 text-max-width-sm mx-auto">
      <h1 class="h2">
        <span>{{ header()?.title }}</span>
      </h1>

      @if (header()?.intro) {
        <p class="lead mt-3 mt-sm-4">{{ header()?.intro }}</p>
      }
    </div>
  </div>
</header>

@if (header()?.image?.url) {
  <div class="page-image text-center">
    <figure class="container d-inline-block w-auto">
      <fstr-image
        class=""
        [image]="header()?.image || undefined"
        [priority]="true"
        [width]="1200"
        [height]="1200"
        [mode]="'max'"
        [scale]="'both'"
      ></fstr-image>
      @if ((header()?.image)!.caption) {
        <figcaption class="caption mt-2">{{ (header()?.image)!.caption }}</figcaption>
      }
    </figure>
  </div>
}
